module.exports = __webpack_public_path__ + "static/media/ic-seat.d9b90114.svg";